/**
 * ChannelHost — ленивая загрузка шторки Канала.
 *
 * Лента, композер и пикеры не нужны на большинстве заходов, а Layout лежит в
 * главном бандле. Чанк тянется при первом открытии и дальше живёт смонтированным
 * (шторка уезжает трансформом, как Центр уведомлений).
 */
import React, { Suspense, lazy, useEffect, useState } from 'react';
import { useChannel } from './ChannelProvider';

const ChannelDrawer = lazy(() => import('./ChannelDrawer'));

export default function ChannelHost() {
  const ch = useChannel();
  const open = !!(ch && ch.open);
  const [mounted, setMounted] = useState(false);
  useEffect(() => { if (open) setMounted(true); }, [open]);
  if (!ch || !ch.enabled || !mounted) return null;
  return (
    <Suspense fallback={null}>
      <ChannelDrawer />
    </Suspense>
  );
}
